import { useState } from "react";
import TailwindBottomButtonView from "../../components/mainBottomButtonView/TailwindBottomButtonView";
import TailwindSideModal from "../../components/commonModal/TailwindSideModal";
import { Checkbox } from "../../components/ui/common/checkbox";
import CommonSplitContainer from "../../components/ui/layout/CommonSplitContainer/CommonSplitContainer";
import { RecipeVariantCol } from "../../config/tableColConstant";

const FilterVarientTableModal = ({
  visibleModal,
  setVisibleModal,
  visibleCols,
  setVisibleCols
}: any) => {
  const [tempCols, setTempCols] = useState<string[]>(visibleCols);

  const handleToggle = (colName: string) => {
    setTempCols(prev =>
      prev?.includes(colName) ? prev?.filter(c => c !== colName) : [...prev, colName]
    );
  };

  const handleApply = () => {
    setVisibleCols(tempCols);
    setVisibleModal(false);
  };

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      setVisibleModal(false);
    }
  };

  return (
    <TailwindSideModal
      open={visibleModal}
      onOpenChange={handleOpenChange}
      title="Add Filters"
    >
      <CommonSplitContainer
        currentHeight={0.9}
        overflowX="hidden"
        topChild={
          <div className="tw-w-full tw-p-1">
            <div className="tw-m-[15px]">
              {RecipeVariantCol.filter((col, idx) => idx > 1 && col.name !== "").map((col, idx) => (
                <div key={idx} className="tw-mb-3 tw-flex tw-items-center tw-gap-3">
                  <Checkbox
                    checked={tempCols.includes(col.name)}
                    onCheckedChange={() => handleToggle(col.name)}
                    className="tw-h-5 tw-w-5 [&_svg]:tw-size-4"
                  />
                  <span
                    className="tw-cursor-pointer tw-text-base tw-font-medium tw-text-foreground"
                    onClick={() => handleToggle(col.name)}
                  >
                    {col.name}
                  </span>
                </div>
              ))}
            </div>
          </div>
        }
        bottomChild={
          <TailwindBottomButtonView
            cancelButtonStatus
            saveButtonStatus
            saveTitle="Apply"
            buttonSize="lg"
            cancelButton={() => setVisibleModal(false)}
            saveButton={() => {
              handleApply();
            }}
          />
        }
      />
    </TailwindSideModal>
  );
};

export default FilterVarientTableModal;
